var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { $ } from '../../simpli';
import { Helper } from '../../main';
import { MaskPresetConfig } from '../config/MaskPresetConfig';
var CnpjMaskPreset = /** @class */ (function (_super) {
    __extends(CnpjMaskPreset, _super);
    function CnpjMaskPreset() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CnpjMaskPreset.prototype, "mask", {
        get: function () {
            return $.t('mask.cnpj');
        },
        enumerable: true,
        configurable: true
    });
    CnpjMaskPreset.prototype.setterTransform = function (input) {
        this.value = Helper.toString(input);
        if (this.value.length === 14) {
            this.isValid = true;
            return this.value;
        }
        this.isValid = this.value.length === 0 ? null : false;
        return null;
    };
    return CnpjMaskPreset;
}(MaskPresetConfig));
export { CnpjMaskPreset };
//# sourceMappingURL=CnpjMaskPreset.js.map